/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import dayjs from 'dayjs';
import type {
  ReturnInfo,
  ReturnPrincipal,
  ReturnStatement,
} from '../models/index';
import {
    ReturnInfoFromJSON,
    ReturnInfoToJSON,
    ReturnPrincipalFromJSON,
    ReturnPrincipalToJSON,
    ReturnStatementFromJSON,
    ReturnStatementToJSON,
} from '../models/index';

export interface ListInvestorReturnPrincipalRequest {
    xCFGINVESTORUSERID: string;
    isin?: string;
}

export interface ListInvestorReturnStatementsRequest {
    xCFGINVESTORUSERID: string;
    period: ListInvestorReturnStatementsPeriodEnum;
    isin?: string;
}

export interface ReturnsInfoRequest {
    xCFGINVESTORUSERID: string;
    isin?: string;
}

/**
 * 
 */
export class InvestorReturnsApi extends runtime.BaseAPI {

    /**
     */
    async listInvestorReturnPrincipalRaw(requestParameters: ListInvestorReturnPrincipalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReturnPrincipal>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling listInvestorReturnPrincipal().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isin'] != null) {
            queryParameters['isin'] = requestParameters['isin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/returns/principal/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReturnPrincipalFromJSON(jsonValue));
    }

    /**
     */
    async listInvestorReturnPrincipal(requestParameters: ListInvestorReturnPrincipalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReturnPrincipal> {
        const response = await this.listInvestorReturnPrincipalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listInvestorReturnStatementsRaw(requestParameters: ListInvestorReturnStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReturnStatement>>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling listInvestorReturnStatements().'
            );
        }

        if (requestParameters['period'] == null) {
            throw new runtime.RequiredError(
                'period',
                'Required parameter "period" was null or undefined when calling listInvestorReturnStatements().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isin'] != null) {
            queryParameters['isin'] = requestParameters['isin'];
        }

        if (requestParameters['period'] != null) {
            queryParameters['period'] = requestParameters['period'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/returns/statements/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReturnStatementFromJSON));
    }

    /**
     */
    async listInvestorReturnStatements(requestParameters: ListInvestorReturnStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReturnStatement>> {
        const response = await this.listInvestorReturnStatementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async returnsInfoRaw(requestParameters: ReturnsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReturnInfo>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling returnsInfo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isin'] != null) {
            queryParameters['isin'] = requestParameters['isin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/returns/info/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReturnInfoFromJSON(jsonValue));
    }

    /**
     */
    async returnsInfo(requestParameters: ReturnsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReturnInfo> {
        const response = await this.returnsInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum ListInvestorReturnStatementsPeriodEnum {
    Monthly = 'MONTHLY',
    Quarterly = 'QUARTERLY',
    Yearly = 'YEARLY'
}
